import { useForm } from 'react-hook-form'
import { useNavigate } from 'react-router'
import { useEffect, useState } from 'react'
import { login } from './api/authApi'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form'
import { toast } from 'sonner'
import { isAppError } from '@/utils/error'
import { isAuthenticated, setAuthSession } from '@/utils/auth'

type LoginFormData = {
  code: string
  password: string
}

export default function LoginPage() {
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)

  // 如果已经登录，跳转到首页
  useEffect(() => {
    if (isAuthenticated()) {
      navigate('/', { replace: true })
    }
  }, [navigate])

  const form = useForm<LoginFormData>({
    defaultValues: {
      code: '',
      password: '',
    },
  })

  const onSubmit = async (data: LoginFormData) => {
    try {
      setLoading(true)
      const loginResult = await login({
        code: data.code,
        password: data.password,
      })

      setAuthSession(loginResult)
      toast.success('登录成功')
      navigate('/', { replace: true })
    } catch (error: unknown) {
      const errorMessage = isAppError(error)
        ? error.message
        : '登录失败，请检查用户编码和密码'
      toast.error(errorMessage)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900 px-4">
      <div className="w-full max-w-md space-y-8">
        <div className="text-center">
          <h2 className="text-3xl font-bold tracking-tight">登录</h2>
          <p className="mt-2 text-sm text-muted-foreground">请输入您的用户编码和密码</p>
        </div>
        <Form {...form}>
          <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-6">
            <FormField
              control={form.control}
              name="code"
              rules={{ required: '请输入用户编码' }}
              render={({ field }) => (
                <FormItem>
                  <FormLabel>用户编码</FormLabel>
                  <FormControl>
                    <Input placeholder="请输入用户编码" autoComplete="username" {...field} />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />
            <FormField
              control={form.control}
              name="password"
              rules={{ required: '请输入密码' }}
              render={({ field }) => (
                <FormItem>
                  <FormLabel>密码</FormLabel>
                  <FormControl>
                    <Input
                      type="password"
                      placeholder="请输入密码"
                      autoComplete="current-password"
                      {...field}
                    />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />
            <Button type="submit" className="w-full" disabled={loading}>
              {loading ? '登录中...' : '登录'}
            </Button>
          </form>
        </Form>
      </div>
    </div>
  )
}
